import { getToggleableStyles } from '../toggleable-styles';

export const getToolbarElementsStyles = (_, { palette = {} }) => ({
  ...getToggleableStyles(palette),
  commonButton: {
    height: '60px !important',
    backgroundColor: '#2F2F2F !important',
    padding: '0px 2px !important',
    borderRadius: '0px !important',
    border: '0px !important',
    '&: focus': {
      color: `${palette.themePrimary} !important`,
    },
    '& .ms-Button-flexContainer': {
      height: 'auto !important',
      display: 'flex !important',
      flexDirection: 'column !important',
    },
  },
  standardButton: {
    maxWidth: 'fit-content !important',
    minWidth: '60px !important',
    '&.global-menu-mmc-dropdown-toggle': {
      maxWidth: 'fit-content !important',
      minWidth: '108px !important',
      padding: '0 4px !important',
    },
    '&.global-menu-asset-library-dropdown-toggle': {
      padding: '0 8px !important',
    },
    '&.global-menu-copilot-dropdown-toggle .global-menu-toolbar-svg-icon': {
      margin: 0,
    },
  },
  activeButton: {
    border: 'none !important',
    outline: 'none !important',
    textDecoration: 'none',
  },
  reportsButton: {
    '&#reports.is-expanded': {
      backgroundColor: `${palette.neutralLighterAlt} !important`,
      color: `${palette.neutralPrimary} !important`,
    },
    '&#reports-v4.is-expanded': {
      backgroundColor: `${palette.neutralLighterAlt} !important`,
      color: `${palette.neutralPrimary} !important`,
    },
    '&#reports:focus::after': {
      outline: '1px solid transparent',
    },
    '&#reports-v4:focus::after': {
      outline: '1px solid transparent',
    },
  },
  notificationsButton: {
    maxWidth: '101px !important',
    minWidth: '101px !important',
  },
  compactButton: {
    maxWidth: '48px !important',
    minWidth: '48px !important',
  },
  menuContainer: {
    padding: 0,
    margin: 0,
    '& li': {
      paddingLeft: '8px',
      color: palette.neutralPrimary,
      fontSize: '12px',
    },
    '& .ms-ContextualMenu-item': {
      paddingLeft: '0px !important',
    },
    '&.global-menu-help-dropdown-menu.dropdown-menu > div > li > a:focus': {
      outline: `1px solid ${palette.neutralSecondary}`,
      '&:after': {
        outline: 'none',
      },
    },
  },
  icon: {
    height: 18,
    textAlign: 'center',
  },
  text: {
    color: 'white',
    height: 18,
    textAlign: 'center',
    font: 12,
  },
  twoLevelMenuContainerVertical: {
    display: 'flex',
    flexDirection: 'column',
  },
  twoLevelMenuContainerHorizontal: {
    display: 'flex',
    flexDirection: 'row',
  },
  menuItem: {
    height: '32px',
    width: 200,
    display: 'flex',
    flexDirection: 'row',
    '& a': {
      height: '32px',
      width: 200,
      padding: '3px 20px',
      fontWeight: 'normal',
      lineHeight: 1.42857143,
    },
  },
  menuContainerOffset: {
    left: 'auto',
    right: '0px',
  },
  toolsMenuContainer: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    maxHeight: 'calc(100vh - 60px)', // 100% of the viewport height, minus the global menu height
  },
  fallbackIcon: {
    fontSize: '16px',
    padding: '0px 8px 0px 8px',
  },
  leftBorder: {
    borderLeft: '1px solid #979797',
  },
  topBorder: {
    borderTop: '1px solid #979797',
  },
  topPadding: {
    paddingTop: '10px',
  },
  multiLevelDropdown: {
    '& a': {
      textDecoration: 'none',
      color: 'inherit',
      fontSize: 14,
      lineHeight: '36px',
    },
  },
  multiLevelDropDownButtonIcon: {
    color: 'inherit',
    fontSize: 16,
    margin: '0 4px',
    top: 2,
    paddingBottom: '6px',
    lineHeight: '16px',
  },
  multiLevelDropDownLabel: {
    fontWeight: 'normal',
    marginLeft: 4,
    marginRight: 4,
  },
  popover: {
    maxWidth: 468,
    border: 'none',
    '& .popover-content': {
      padding: 0,
      fontSize: '14px',
    },
    '&.popover.left': {
      marginLeft: 60,
      '& .arrow': {
        display: 'none',
      },
    },
  },
});
